<div class="container psa-duplicate-container p-3">
  <!-- Titolo della finestra di dialogo -->
  <h4
    *ngIf="typeDuplicatePsa === 'MATRICE_RISCHIO'">{{ 'map.sidebar.psa.duplicazioneMatrice.title_matrice' | translate }}</h4>
  <h4
    *ngIf="typeDuplicatePsa === 'CHECKLIST'">{{ 'map.sidebar.psa.duplicazioneMatrice.title_checklist' | translate }}</h4>
  <p class="text-muted d-flex justify-content-between">
    <span>{{ 'map.sidebar.psa.duplicazioneMatrice.from' | translate }} {{ psaObject.search_term }}</span>

    <mat-icon color="primary" [matTooltip]="'map.sidebar.psa.duplicazioneMatrice.description' | translate">
      info
    </mat-icon>
  </p>

  <mat-tab-group class="mb-3">
    <mat-tab label="RICERCA SU MAPPA">
      <!-- Campo di input per il progetto -->
      <div class="row" style="margin-right:10px">
        <div class="col-6 form-group">
          <mat-form-field class="mt-2" appearance="outline">
            <mat-label>{{ 'map.drawing_tool.radius' | translate }}</mat-label>
            <input type="number" (input)="manualUpdateCircle()" [(ngModel)]="circleOptions.radius" matInput>
          </mat-form-field>
        </div>
        <div class="col-6 d-flex align-items-center">
          <div class="mx-2 drawing-tool-icon-container">
            <button mat-icon-button aria-label="Circle Button" color="accent"
                    *ngIf="!isDrawn"
                    [matTooltip]="'map.drawing_tool.circle' | translate"
                    matTooltipPosition="below"
                    matTooltipShowDelay="500"
                    (click)="startDraw()">
              <mat-icon>adjust</mat-icon>
            </button>
            <button mat-icon-button aria-label="Circle Button" color="accent"
                    *ngIf="isDrawn"
                    [matTooltip]="'common.cancel' | translate"
                    matTooltipPosition="below"
                    matTooltipShowDelay="500"
                    (click)="endDraw()">
              <mat-icon>block</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="RICERCA DA LABEL">
      <div class="form-group">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'map.sidebar.psa.search' | translate }}</mat-label>
          <input matInput [(ngModel)]="filterTerm" (keyup)="onInputChange()" />
        </mat-form-field>
      </div>
    </mat-tab>
  </mat-tab-group>

  <mat-accordion>
    <mat-expansion-panel hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span class="mx-2">{{ 'map.sidebar.psa.duplicazioneMatrice.selected_items' | translate }}</span>
          <span *ngIf="selectedItems.length > 0" @fadeAnimation [matBadge]="selectedItems.length"
                matBadgeOverlap="false" class="demo-section"></span>

          <span *ngIf="selectedItems.length === MAX_SELECTED_ITEMS_NUMBER">
            {{ 'map.sidebar.psa.duplicazioneMatrice.max_number' | translate }}
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="scrollable-div">
        <div *ngIf="selectedItems.length === 0"><b>{{ 'map.sidebar.psa.duplicazioneMatrice.empty_list' | translate }}</b></div>
        <mat-chip-set *ngIf="selectedItems.length > 0" #chipList>
          <mat-chip-option *ngFor="let item of selectedItems" (removed)="remove(item)">
            {{ item.search_term }}
            <button matChipRemove (click)="remove(item)">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-option>
        </mat-chip-set>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <!-- Checkbox per la selezione dei progetti -->
  <div class="form-group mt-3">
    <div class="scrollable-div" *ngIf="listEntities">
      <ng-container *ngFor="let entity of listEntities">
        <mat-checkbox class="d-block"
                      [ngClass]="{'not-allowed' : selectedItems.length >= MAX_SELECTED_ITEMS_NUMBER}"
                      @fadeAnimation
                      (change)="toggleSelection(entity)"
                      [(ngModel)]="entity.selected"
                      *ngIf="!isSelected(entity)">
          {{ entity.search_term }}
        </mat-checkbox>
      </ng-container>

      <div *ngIf="listEntities.length === 0">
        {{ 'map.sidebar.psa.duplicazioneMatrice.noElementsFound' | translate }}
      </div>
    </div>
  </div>

  <!-- Pulsanti di azione -->
  <div class="d-flex justify-content-end mt-4">
    <button mat-button color="warn"
            (click)="closeModal()">{{ 'map.sidebar.psa.duplicazioneMatrice.cancel' | translate }}
    </button>
    <button mat-raised-button color="primary" [disabled]="selectedItems.length === 0"
            (click)="duplicateEntity()">{{ 'map.sidebar.psa.duplicazioneMatrice.apply' | translate }}
    </button>
  </div>
</div>
